module.exports = __webpack_public_path__ + "img/2021_2_1_mouthhole.c1f22aca.jpg";